export const GUTTER_WIDTH = 240;
export const GUTTER_GAP = 16;

const PADDING = 8;
const BLOCK_GAP = 8;

export interface GutterBlock {
  top: number;
  height: number;
}

/** Pack measured CSS-pixel blocks in script order without clipping their content. */
export function packGutter(
  blocks: readonly GutterBlock[],
  pageHeight: number,
): { tops: number[]; height: number } {
  if (blocks.length === 0) return { tops: [], height: pageHeight };

  const tops: number[] = [];
  let nextTop = PADDING;
  let minimumHeight = PADDING * 2;
  for (let i = 0; i < blocks.length; i++) {
    const block = blocks[i]!;
    const top = Math.max(block.top, nextTop);
    tops.push(top);
    nextTop = top + block.height + BLOCK_GAP;
    minimumHeight += block.height + (i > 0 ? BLOCK_GAP : 0);
  }

  // Extend only when the content itself cannot fit, not for a low preferred anchor.
  const height = Math.max(pageHeight, minimumHeight);
  let bottom = height - PADDING;
  for (let i = blocks.length - 1; i >= 0; i--) {
    tops[i] = Math.min(tops[i]!, bottom - blocks[i]!.height);
    bottom = tops[i]! - BLOCK_GAP;
  }
  return { tops, height };
}
